// import React, { useEffect, useState } from "react";

// function ScrollToTopButton() {
//   const [showButton, setShowButton] = useState(false);
//   useEffect(() => {
//     const handleScroll = () => {
//       if (window.scrollY > 300) {
//         setShowButton(true);
//       } else {
//         setShowButton(false);
//       }
//     };
//     window.addEventListener("scroll", handleScroll);
//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, []);

//   const scrollToTop = () => {
//     window.scrollTo({
//       top: 0,
//       behavior: "smooth",
//     });
//   };

//   return (
//     <>
//       {showButton && (
//         <button
//           onClick={scrollToTop}
//           style={{
//             position: "fixed",
//             bottom: "20px",
//             right: "20px",
//             width: "40px",
//             height: "40px",
//             borderRadius: "50%",
//             border: "none",
//             background: "#E13236",
//             color: "#fff",
//             fontSize: "22px",
//             cursor: "pointer",
//             zIndex: 9999,
//             boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
//           }}
//         >
//             <i className="bi bi-arrow-up-short"></i>
//         </button>
//       )}
//     </>
//   );
// }

// export default ScrollToTopButton;

import React, { useEffect, useState } from "react";

function ScrollToTopButton() {
  const [showButton, setShowButton] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight =
        document.documentElement.scrollHeight - window.innerHeight;

      const percent = (scrollTop / docHeight) * 100;

      setProgress(percent);
      setShowButton(scrollTop > 300);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const radius = 18;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (progress / 100) * circumference;

  return (
    <>
      {showButton && (
  <div
    onClick={scrollToTop}
    style={{
      position: "fixed",
      bottom: "130px",
      right: "20px",
      width: "44px",
      height: "44px",
      cursor: "pointer",
      zIndex: 99,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        transform: "rotate(-90deg)",
      }}
    >
      {/* Background Circle */}
      <circle
        cx="22"
        cy="22"
        r={radius}
        stroke="#ddd"
        strokeWidth="3"
        fill="none"
      />

      {/* Progress Circle */}
      <circle
        cx="22"
        cy="22"
        r={radius}
        stroke="#E13236"
        strokeWidth="3"
        fill="none"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
        style={{
          transition: "stroke-dashoffset 0.15s linear",
        }}
      />
    </svg>

    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        scrollToTop();
      }}
      style={{
        position: "relative",
        zIndex: 2,
        width: "34px",
        height: "34px",
        borderRadius: "50%",
        border: "none",
        background: "#fff",
        color: "#7c0808",
        fontSize: "24px",
        cursor: "pointer",
        padding: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        lineHeight: 1,
        boxShadow: "0 1px 5px rgba(0,0,0,0.15)",
      }}
    >
      <i className="bi bi-arrow-up-short"></i>
    </button>
  </div>
)}
    </>
  );
}

export default ScrollToTopButton;